<form [formGroup]="targetForm">
  <section class="sideRight-body">

    <div id="container">
      <div id="contentC">
        <label>
          <i class="fas fa-asterisk"></i> <b> Activity Name</b>
          <span *ngIf="f.name.errors && f.name.touched">
            <span class="required-error" *ngIf="f.name.errors.required">
              (Required)
            </span>
            <span class="required-error" *ngIf="f.name.dirty && f.name.errors.UniqueAName">
              (Activity name exists)
            </span>
          </span>
          <input class="black-input opposite-colors" type="text" (input)="onEditActivityData()" no-special-chars="<>"
            (blur)="trimSpecialChar('name');" formControlName="name" maxlength="100"
            placeholder="Activity name needs to be unique within a study">
        </label>
      </div>
    </div>

    <div id="container" style="margin-bottom: 1em;">
      <div id="contentA" class="ei-employeeNumber mt-2">
          <label>
              <i class="fas fa-asterisk"></i><b> Activity Type</b>
              <span class="required-error" *ngIf="showActivitySubTypeValidation">
                  (Required)
              </span>
          </label>
          <div class="input-icon-right" [ngClass]="{'error-section': showActivitySubTypeValidation}">
              <custom-dropdown [options]="dropdownOptions" [selectText]="selectedActivitySubType" [buttonHeight]="true" class="dropdown-section"
                  [isDisabled]="disableActivitySubtype" (optionSelectedEvent)="onActivitySubTypeSelected($event)">
              </custom-dropdown>
          </div>
      </div>
      <div id="contentB" class="ei-name mt-2" style="
              padding-top: 37px;
              display: flex;
              align-items: flex-end;">
          <label style="width: 65%;">
              <i class="fas fa-asterisk"></i><b> Qualified %</b><br />
          </label>
          <div class="input-icon-right" style="
                  width: 45%;
              ">
              <input class="black-input opposite-colors" (input)="onEditActivityData()" formControlName="percentage"
                  type="number" min="0" value="100" required>
              <i class="fas fa-percent" style="left: 68%;"></i>
          </div>
      </div>
  </div>

  <div *ngIf="f.percentage.errors && f.percentage.errors.pattern || (f.percentage.touched && !f.percentage.valid)">
      <div class="error-message" *ngIf="f.percentage.touched && !f.percentage.valid">
        Qualified % must be a number between 0-100, and can have up to two decimal places. 
      </div>
  </div>

  <div id="container">
    <div id="contentC">
        <label>
            <i class="fas fa-asterisk"></i><b> Activity Group</b>
            <span *ngIf="f.activityGroup.errors && f.activityGroup.touched">
                <span class="required-error" *ngIf="f.activityGroup.errors.required">
                    (Required)
                </span>
            </span>
            <input class="black-input opposite-colors clients-autocomplete"
                [ngClass]="{'ng-invalid' :  !isActivityGroupSelected }"
                placeholder="Search for an existing group or enter a new group" type="text"
                no-special-chars="#!$%^<>+=" [kpmgUiTypeahead]="filterActivityGroup"
                [resultTemplate]="ag" [editable]="true"
                [inputFormatter]="activityGroupFormatter" (input)="onEditActivityData()"
                (blur)="activityGroupValidationDelayer($event.target.value)" formControlName="activityGroup">

            <ng-template #ag let-c="result" let-t="term">
                <kpmg-ui-highlight class="create-engagement-typeahead" [result]="c.activityGroup" [term]="t">
                </kpmg-ui-highlight>&nbsp;
            </ng-template>
        </label>
    </div>
  </div>

    <div id="container">
      <div id="contentC">
        <label for="description">
          <b>Activity Description</b>
          <textarea class="black-input opposite-colors" rows="5" (input)="onEditActivityData()" 
            placeholder="A maximum of 500 characters is allowed." formControlName="description" maxlength="500"></textarea>
        </label>
      </div>
    </div>

  </section>

  <footer class="endFormSubmit info-tile">
    <button type='button' class="btn btn-success" [disabled]="(!targetForm.valid || isDisabled)"
      (click)="editActivity()">Save Changes</button> &nbsp;
    <button class="btn kpmg-button--flat" (click)="rightSideDrawerService.closeRightSideDrawer()">Cancel</button>
  </footer>
</form>